// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching company stats
// export const fetchCompanyStats = createAsyncThunk(
//   "companyStats/fetchCompanyStats",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/company-activity-stats"
//       );
//       const result = await response.json();

//       if (result.success) {
//         return result.data;
//       } else {
//         return rejectWithValue("Failed to fetch company stats");
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const companyStatsSlice = createSlice({
//   name: "companyStats",
//   initialState: {
//     totalCompanies: 100,
//     activeCompanies: 75,
//     inactiveCompanies: 25,
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanyStats.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanyStats.fulfilled, (state, action) => {
//         state.loading = false;
//         state.totalCompanies = action.payload.totalCompanies;
//         state.activeCompanies = action.payload.activeCompanies;
//         state.inactiveCompanies = action.payload.inactiveCompanies;
//       })
//       .addCase(fetchCompanyStats.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearError } = companyStatsSlice.actions;
// export default companyStatsSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching company stats
export const fetchCompanyStats = createAsyncThunk(
  "companyStats/fetchCompanyStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/company-activity-stats`
      );
      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue("Failed to fetch company stats");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const companyStatsSlice = createSlice({
  name: "companyStats",
  initialState: {
    totalCompanies: 100,
    activeCompanies: 75,
    inactiveCompanies: 25,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyStats.fulfilled, (state, action) => {
        state.loading = false;
        state.totalCompanies = action.payload.totalCompanies;
        state.activeCompanies = action.payload.activeCompanies;
        state.inactiveCompanies = action.payload.inactiveCompanies;
      })
      .addCase(fetchCompanyStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = companyStatsSlice.actions;
export default companyStatsSlice.reducer;
